const inrFormatter = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

/** ₹1,234 */
export function formatINR(amount: number): string {
  return `₹${inrFormatter.format(Math.round(amount))}`;
}

/** 1:05 PM */
export function formatClock(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

/** Saturday, 3 October */
export function formatLongDate(d: Date): string {
  return d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
}

/** 38:12 under an hour, 1:02:45 from an hour. */
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

/** Readable short span, to the nearest minute: "< 1 min", "1 min", "45 mins", "1 hr", "2 hrs 5 mins". */
export function formatShortDuration(ms: number): string {
  const total = Math.round(Math.max(0, ms) / 60_000);
  if (total === 0) return '< 1 min';
  const h = Math.floor(total / 60);
  const m = total % 60;
  const hrs = h ? `${h} ${h === 1 ? 'hr' : 'hrs'}` : '';
  const mins = m ? `${m} ${m === 1 ? 'min' : 'mins'}` : '';
  return [hrs, mins].filter(Boolean).join(' ');
}

/** 98450 12345 → +91 98450 12345 */
export function formatPhone(phone: string): string {
  const d = phone.replace(/\D/g, '');
  return d.length === 10 ? `+91 ${d.slice(0, 5)} ${d.slice(5)}` : phone;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');
}

/** Parses a money input value; empty or invalid becomes 0. */
export function toAmount(value: string): number {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** 7 Oct, 9:42 PM (with the year when it isn't this year). */
export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  const sameYear = d.getFullYear() === new Date().getFullYear();
  const day = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', ...(!sameYear && { year: 'numeric' }) });
  return `${day}, ${formatClock(d)}`;
}

/** "Kiran" from "Kiran Rao": two names on a booking show first names only. */
export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? '';
}
